module.exports = __webpack_public_path__ + "static/media/number_line.58e6689c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/number_line.svg
// module id = 1403
// module chunks = 0